import axios from 'axios';

export default {
    addToNewsLetter(email) {
        const newsLetter={
            email:email
        }
        return axios.post('/api/news/letter/add', newsLetter ) 
            .then(response => {
                if (response && response.data) return response.data;
            })
            .catch(error => {
                console.log(error);
            });
    },
}